import React, { useContext, useEffect, useRef, useState } from 'react'
import SearchContext from '../context/SearchContext'
import Sort from './Sort'
import Tags from './Tags'

const StickyHeader = () => {

    const {carsInStock } = useContext(SearchContext)

    const [isSticky, setIsSticky] = useState(false)

    const headerRef = useRef()

    // mount 
    useEffect(()=>{
        const cachedRef = headerRef.current,
            observer = new IntersectionObserver(
                ([e]) => setIsSticky(e.intersectionRatio < 1),
                {threshold: [1]}
            )

        observer.observe(cachedRef)
        
        // unmount
        return function(){
            observer.unobserve(cachedRef)
        }
    }, [])

    return (
        <div ref={headerRef} className={'cars-header' + (isSticky ? ' sticky' : '')}>
            <h3><span>{carsInStock}</span> {carsInStock === 1 ? 'bil':'bilar'} i lager</h3>
            {isSticky  &&
                <Tags />
            }
            <Sort />
        </div>
    )

}

export default StickyHeader